module.exports = __webpack_public_path__ + "img/MR.d971cfc7.png";